import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDITIONAL_COSTS_GET_MANY } from 'api/query-keys';
import type { TAdditionalCostRes, TUpdateAdditionalCostReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

interface IUseUpdateAdditionalCostParams {
  orderId?: number;
  tripId?: number;
}

export const useUpdateAdditionalCost = (additionalCostId: number, params: IUseUpdateAdditionalCostParams) => {
  const queryClient = useQueryClient();

  const { orderId, tripId } = params;

  const queryKey: string[] = [ADDITIONAL_COSTS_GET_MANY];
  if (orderId) {
    queryKey.push(String(orderId));
  } else if (tripId) {
    queryKey.push(String(tripId));
  }

  return useMutationBase<TAdditionalCostRes, unknown, TUpdateAdditionalCostReq>({
    mutationFn: async (data: TUpdateAdditionalCostReq) => {
      const res = await http.patch<TAdditionalCostRes>(`/v1/additional-costs/${additionalCostId}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
};
